<template>
    <!-- <v-text-field v-bind="{ ...attrs_input_common, ...$attrs }" class="rounded-0" @input="input"> -->
    <v-text-field v-model="modelValue" v-bind="{ ...attrs_input_common, ...$attrs }" class="rounded-0" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-text-field>
</template>

<script>
import { attrs_input_common } from "@/assets/variables";

export default {
    props: {
        // value: { type: String }
        value: { type: String, default: null },
    },
    components: {},
    data() {
        return {
            attrs_input_common,
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {
        // input(string) {
        //     this.$emit("string", string)
        // }
    },
};
</script>

<style lang="scss" scoped>
.v-text-field{
    --input-focused-border-color: var(--v-secondary-base);
    --input-label-color: var(--v-grey-lighten1);
    --input-focused-label-color: #fff;
    --input-color: #fff;
}
</style>
